const form2 = {
  formId2: "new-user-form-2",
  formField2: {
    period: {
      name: "period",
      label: "[01] Kỳ tính thuế:",
      type: "text",
      placeholder: "Kỳ tính thuế",
      errorMsg: "Vui lòng nhập kỳ tính thuế",
    },
    firstTime: {
      name: "firstTime",
      label: "[02] Lần đầu:",
      type: "text",
      placeholder: "Kỳ tính thuế",
      errorMsg: "Vui lòng nhập kỳ tính thuế",
    },
    additional: {
      name: "additional",
      label: "[03] Bổ sung lần thứ:",
      type: "text",
      placeholder: "Bổ sung lần thứ",
      errorMsg: "Vui lòng nhập lần bổ sung",
    },
    //
    taxpayers: {
      name: "taxpayers",
      label: "[04] Tổ chức, doanh nghiệp khai thay, nộp thay:",
      type: "text",
      placeholder: "Tổ chức, doanh nghiệp khai thay, nộp thay",
      errorMsg: "Vui lòng nhập tên tổ chức, doanh nghiệp khai thay, nộp thay",
    },
    taxCode: {
      name: "taxCode",
      label: "[05] Mã số thuế của tổ chức, doanh nghiệp khai thay, nộp thay:",
      type: "text",
      placeholder: "Mã số thuế của tổ chức, doanh nghiệp khai thay, nộp thay",
      errorMsg: "Vui lòng nhập mã số thuế của tổ chức, doanh nghiệp khai thay, nộp thay",
    },
    taxAgentName: {
      name: "taxAgentName",
      label: "[12] Tên đại lý thuế (nếu có):",
      type: "text",
      placeholder: "Đại lý thuế",
      errorMsg: "Vui lòng nhập tên đại lý thuế",
    },
    taxAgentCode: {
      name: "taxAgentCode",
      label: "[13] Mã số thuế:",
      type: "text",
      placeholder: "Mã số thuế",
      errorMsg: "Vui lòng nhập mã số thuế",
    },
    ///
    chiefAccountant: {
      name: "chiefAccountant",
      label: "Họ và tên:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên nhân viên đại lý thuế",
    },
    certificateNumber: {
      name: "certificateNumber",
      label: "Chứng chỉ hành nghề số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập số chứng chỉ hành nghề",
    },
    unitHeads: {
      name: "unitHeads",
      label: "Người ký:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên người ký",
    },
    dateFounded: {
      name: "dateFounded",
      label: "Ngày ký:",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn ngày ký",
    },
  },
};

export default form2;
